import { useEffect, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { TaxReturnFormValues } from '../types/tax-return';

const FIELD_WEIGHTS = {
  personal: 0.4, // 40%
  banking: 0.3, // 30%
  documents: 0.2, // 20%
  service: 0.1, // 10%
};

export function useCompletionProgress(form: UseFormReturn<TaxReturnFormValues>) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const subscription = form.watch((data) => {
      const values = data as TaxReturnFormValues;
      let totalProgress = 0;

      // Personal details (40%)
      if (values.full_name && values.email && values.phone && values.address && values.tfn) {
        totalProgress += FIELD_WEIGHTS.personal;
      }

      // Banking details (30%)
      if (values.bsb && values.account_number && values.account_name) {
        totalProgress += FIELD_WEIGHTS.banking;
      }

      // Document upload (20%) - This will be handled by the DocumentUploadSection
      // We'll assume it's complete if there are documents
      if (values.documents_uploaded) {
        totalProgress += FIELD_WEIGHTS.documents;
      }

      // Service selection (10%)
      if (values.service_type && values.service_id) {
        totalProgress += FIELD_WEIGHTS.service;
      }

      setProgress(Math.round(totalProgress * 100));
    });

    return () => subscription.unsubscribe();
  }, [form]);

  return progress;
}